export default "__VITE_ASSET__5e2c1efe__"